<template>
    <div class="micro-lesson-content" :native="false">
        <el-scrollbar class="micro-lesson-list">
            <div class="micro-lesson">
                <div
                    class="micro-lesson-item"
                    v-for="item in microLessonList"
                    v-if="microLessonList.length > 0"
                    @click="viewDetail(item)"
                >
                    <div class="micro-lesson-cover">
                        <img
                            src="../../../assets/img/image/microLesson.png"
                            alt=""
                            class="micro-lesson-icon"
                        />
                    </div>
                    <span class="micro-lesson-name" :title="item.resource_title">{{
                        item.resource_title
                    }}</span>
                </div>
                <div v-if="microLessonList.length === 0" class="no-data">
                    <span>暂无数据</span>
                </div>
            </div>
        </el-scrollbar>
        <ResourceDialog
            :dialogVisible="dialogVisible"
            :src="src"
            @closeDialog="closeDialog"
        ></ResourceDialog>
    </div>
</template>

<script>
import ResourceDialog from '../../components/ResourceDialog'

export default {
    name: 'MicroLesson',
    components: {
        ResourceDialog
    },
    props: ['searchInput'],
    data() {
        return {
            microLessonList: [],
            src: '',
            dialogVisible: false
        }
    },
    created() {
        this.getCourseInfo()
    },
    watch: {
        searchInput(d) {
            if (d !== '') {
                let arr = []
                for (let i = 0; i < this.microLessonList.length; i++) {
                    if (this.microLessonList[i].resource_title.indexOf(d) !== -1) {
                        arr.push(this.microLessonList[i])
                    }
                }
                this.microLessonList = arr
            } else {
                this.microLessonList = []
                this.getCourseInfo()
            }
        }
    },
    methods: {
        //获取微课列表
        getCourseInfo() {
            let params = {
                id: this.$route.query.course_id
            }
            this.$shttp.axiosGetBy(
                this.$api.courseinfo,
                params,
                res => {
                    if (res.code === 200) {
                        // console.log('微课',res.data.reslist)
                        for (let i = 0; i < res.data.reslist.length; i++) {
                            if (res.data.reslist[i].resource_type_id === 3) {
                                this.microLessonList.push(res.data.reslist[i])
                            }
                        }
                    }
                },
                error => {
                    console.log(error)
                }
            )
        },
        viewDetail(item) {
            this.src = item.file_preview_path
            this.dialogVisible = true
        },
        closeDialog() {
            this.src = ''
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped lang="scss">
.micro-lesson-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    .micro-lesson-list {
        flex: 1;
        width: 100%;
        height: 1%;
        background-color: #fff;
        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
        }
        .micro-lesson {
            padding: 0 20px;
            display: flex;
            flex-wrap: wrap;
            .micro-lesson-item {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin: 30px 16px 0;
                cursor: pointer;
                border-radius: 10px;
                &:hover {
                    transform: scale(1.2);
                    transition: 1s;
                }
                .micro-lesson-cover {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 107px;
                    height: 107px;
                }
                img.micro-lesson-icon {
                    max-width: 100%;
                    max-height: 100%;
                    border-radius: 5px;
                }
                span.micro-lesson-name {
                    color: #333;
                    font-size: 12px;
                    margin-top: 10px;
                    display: block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 107px;
                    text-align: center;
                }
            }
        }
    }
}
.no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-top: 50px;
}
</style>
